import React from 'react'
import Layout from '../../components/Layout'
import Intro from './Intro'
import ContactForm from './ContactForm'
// import Footer from './Footer'



const Contact = () => {
  return (
    <Layout>
      <Intro />
      <ContactForm />
      {/* <Footer /> */}
    </Layout>
  )
}

export default Contact